var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-page',{staticClass:"not-found",attrs:{"title":"Not Found"}},[_c('v-col',[_c('p',{staticClass:"notice"},[_vm._v(" The URL you requested does not match a page we can show you. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }